import React from "react";
import { useNavigate } from "react-router-dom";

//material ui
import { Button } from "@mui/material";
import { useTheme } from "@mui/styles";

//icons
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const useStyles = (theme, mainColor, secondaryColor, iconColor, width) => ({
  icon: {
    p: "6px",
    maxHeight: { xs: "32px", sm: "32px", md: "32px", lg: "32px", xl: "32px" },
    maxWidth: { xs: "32px", sm: "32px", md: "32px", lg: "32px", xl: "32px" },
    borderRadius: "58px",
    bgcolor: theme.palette.white.secondary,
    color: iconColor,
    ml: { xs: "3px", sm: "6px", md: "9px", lg: "12px", xl: "15px" },
  },
  button: {
    borderRadius: "100px",
    color: theme.palette.white.secondary,
    background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    fontSize: {
      xs: "14px",
      sm: "14.5px",
      md: "20px",
      lg: "20px",
      xl: "20px",
    },
    lineHeight: {
      xs: "25.2px",
      sm: "27",
      md: "28.8",
      lg: "30.6",
      xl: "32.4px",
    },
    height: {
      xs: "52px",
      sm: "42.25px",
      md: "46.5px",
      lg: "50.75px",
      xl: "55px",
    },
    width: {
      xs: "197px",
      sm: "179.5px",
      md: width ? width : "203px",
      lg: width ? width : "226.5",
      xl: width ? width : "245px",
    },
    textTransform: "none",
    "&:hover": {
      color: theme.palette.white.secondary,
      background: `linear-gradient(103deg, ${mainColor}, ${secondaryColor})`,
    },
    letterSpacing: { xs: "0.32px", md: "0.36px" },
  },
});

const ApplyButton = ({
  mb,
  mt,
  iconSx,
  sx,
  mainColor,
  secondaryColor,
  iconColor,
  width,
  navigateTo,
  onClick,
  children,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme, mainColor, secondaryColor, iconColor, width);
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate(navigateTo);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Button
      endIcon={<ArrowForwardIosIcon sx={{...classes.icon, ...iconSx}} />}
      variant="contained"
      sx={{ ...classes.button, mb, mt, ...sx }}
      onClick={onClick || handleRedirect}
    >
      {children || "Aplicar"}
    </Button>
  );
};

export default ApplyButton;
